import * as api from '../api';
// import { NEW_ORDER } from '../constants/action-types';

export const newOrder = (form, token, setIsSendCart, setDisabledBtn, setSendOrder, setOrder, sendClearCart) => dispatch => {
  api.newOrder(form, token, setIsSendCart, setDisabledBtn, setSendOrder, setOrder, sendClearCart).then(newOrder => {
      // dispatch(receiveNewOrder(newOrder));
      return newOrder;
  })
}

// export const receiveNewOrder = newOrder => ({
//   type: NEW_ORDER,
//   newOrder
// });